export default "__VITE_ASSET__rZ5oYlSp__"